<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="notes && ready">
        <dx-data-grid #dataGrid keyExpr="id" [dataSource]="notes" [showBorders]="true" [height]="500" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="dealerName" caption="Dealer"></dxi-column>
            <dxi-column dataField="notes" caption="Notes"></dxi-column>
            <dxi-column dataField="created" caption="Created" dataType="date"></dxi-column>
            <dxi-column dataField="createdBy" caption="Created By"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="dealer-notes-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-secondary me-2" (click)="edit()">New</button>
                <button class="btn btn-sm btn-success" (click)="edit(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="notes" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
